import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RegisterBulkComponent} from './register-bulk.component';

const routes: Routes = [
  {path: '', component: RegisterBulkComponent},
  {path: ':id', component: RegisterBulkComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterBulkRoutingModule { }
